var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Input',{ref:"xInput",attrs:{"On-focus":"onfucus"},on:{"on-blur":_vm.onblur},nativeOn:{"input":function($event){return _vm.inputHandler($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }